import {ComponentRef, Directive, ElementRef, HostListener, Input, OnDestroy, OnInit, TemplateRef} from '@angular/core';
import {Overlay, OverlayPositionBuilder, OverlayRef} from "@angular/cdk/overlay";
import {ComponentPortal} from "@angular/cdk/portal";
import {CustomTooltipComponent} from "../component/custom-tooltip/custom-tooltip.component";

@Directive({
  selector: '[appCustomTooltip]'
})
export class CustomTooltipDirective implements OnInit, OnDestroy{

  @Input() tooltipTemplate: TemplateRef<any>;
  private overlayRef: OverlayRef;

  constructor(private overlay: Overlay, private elementRef: ElementRef,
              private overlayPositionBuilder: OverlayPositionBuilder) {}

  ngOnInit(): void {
    // Define position strategies for the overlay.
    // Normally the overlay is rendered above the elementRef but if there is not enough space it is rendered underneath the elementRef
    const positionStrategy = this.overlayPositionBuilder
        .flexibleConnectedTo(this.elementRef)
        .withPositions([
          {
            originX: 'center',
            originY: 'top',
            overlayX: 'center',
            overlayY: 'bottom',
            offsetY: -10
          },
          {
            originX: 'center',
            originY: 'bottom',
            overlayX: 'center',
            overlayY: 'top',
            offsetY: 10
          }
        ]);
    this.overlayRef = this.overlay.create({positionStrategy});
  }

  ngOnDestroy(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose(); // Detach and clean up the overlay when the directive's host element is destroyed
    }
  }

  /**
   * HostListener for the 'mouseenter' event on the host element.
   * Shows the tooltip if it is not already attached.
   */
  @HostListener('mouseenter')
  public show(): void{
    if(this.overlayRef && !this.overlayRef.hasAttached()){
      const tooltipPortal = new ComponentPortal(CustomTooltipComponent);
      const tooltipRef: ComponentRef<CustomTooltipComponent> = this.overlayRef.attach(tooltipPortal)
      tooltipRef.instance.tooltipTemplate = this.tooltipTemplate;
    }
  }

  /**
   * HostListener for the 'mouseout' event on the host element.
   * Hides the tooltip if the mouse pointer moves outside the host element into another element which is not a child of the host element
   *
   * @param relatedTarget Related target element of the mouseout event
   */
  @HostListener('mouseout', ['$event.relatedTarget'])
  public hide(relatedTarget: Node): void {
    // Check if the overlayRef exists and if the related target is not contained within the host element
    if (this.overlayRef && !this.elementRef.nativeElement.contains(relatedTarget)) {
      this.overlayRef.detach();
    }
  }
}
